import axios from "axios";
import api from "../api/api";

/*
=========================================================
ORGANIZATION SERVICE
=========================================================

Handles all API calls related to NGO organization profile.

Benefits:
• Centralized organization data fetching
• Error-safe API calls
• Uses global Axios instance
• Supports array response from backend
*/


// ======================================================
// FALLBACK API URL (used only if api instance fails)
// ======================================================
const API_URL = "http://127.0.0.1:8000/api/core/";


// ======================================================
// GET ORGANIZATION PROFILE
// ======================================================
export const getOrganization = async () => {
  try {

    // Preferred method using centralized api client
    const response = await api.get("core/");

    /*
    Backend returns a LIST
    Example:
    [
      { organization data }
    ]
    */

    if (Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0];
    }

    return null;

  } catch (error) {

    console.error("Error fetching organization data:", error);

    // --------------------------------------------------
    // Fallback request using direct axios (safety layer)
    // --------------------------------------------------
    try {
      const fallbackResponse = await axios.get(API_URL);

      if (
        Array.isArray(fallbackResponse.data) &&
        fallbackResponse.data.length > 0
      ) {
        return fallbackResponse.data[0];
      }

      return null;

    } catch (fallbackError) {
      console.error("Fallback API request failed:", fallbackError);
      return null;
    }
  }
};